module.exports = __webpack_public_path__ + "static/intertec_screen_5-9e9be39335c1d4460aaa586f5d854450.jpg";